export default __webpack_public_path__ + "static/media/booked.def16797.png";